module.exports = __webpack_public_path__ + "img/toninguy.0dff3f47.png";